import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { IonSelect, IonSlides } from '@ionic/angular';
import { UiServices } from 'src/app/services/ui-services';
import { ContactSocialComponent } from '../../components/contact-social/contact-social.component';
import { SlideService } from 'src/app/services/slide.service';
import { isPlatformBrowser } from '@angular/common';
interface GalleryMedia {
  file: string | null;
  small_file: string | null;
}
4;
@Component({
  selector: 'app-galleries-open',
  templateUrl: './galleries-open.component.html',
  styleUrls: ['./galleries-open.component.scss'],
})
export class GalleriesOpenComponent implements OnInit {
  @Input() galleries: any;
  @ViewChild('descriptionEl', { static: true })
  descriptionEl: ElementRef<HTMLDivElement>;
  @ViewChild('selectBranch') selectBranch: IonSelect;
  @ViewChild('slidesGallery') slides: IonSlides;
  public reachedEnd = false;
  public isStart = true;

  public mediaImages: GalleryMedia[] = [];
  public type = 'galleries';

  constructor(
    private uiSv: UiServices,
    private slideSv: SlideService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }

    const matches = matchMedia('(max-width: 578px)');
    this.verifyMatches(matches.matches);
    matches.addEventListener('change', (ev) => {
      this.verifyMatches(ev.matches);
    });

    if (this.galleries) {
      this.descriptionEl.nativeElement.innerHTML = this.galleries?.description;
    }
  }

  verifyMatches(matches: boolean) {
    if (matches) {
      this.type = 'galleriesSmallFile';
      this.mediaImages = this.galleries.media
        .filter((x: GalleryMedia) => x.small_file)
        .map((x) => {
          x.file = x.small_file;
          return x;
        });

      if (!this.mediaImages.length) {
        this.type = 'gallerie';
        this.mediaImages = this.mediaImages = this.galleries.media.filter(
          (x: GalleryMedia) => !x.small_file
        );
      }
    } else {
      this.type = 'gallerie';
      this.mediaImages = this.galleries.media.filter(
        (x: GalleryMedia) => !x.small_file
      );
    }
    console.log('this.mediaImages :>> ', this.mediaImages);
  }

  open(ev) {
    ev && window.open(ev, '_blank');
  }

  slideTo(direction) {
    direction ? this.slides.slideNext(400) : this.slides.slidePrev(400);
  }

  async openBranch(select: IonSelect) {
    if (this.galleries?.branchContactId.length === 1) {
      this.showSocials(this.galleries?.branchContactId[0]);
      return;
    }
    select.open();
  }

  async changedSlide(ev) {
    this.reachedEnd = ev.el.dom7ElementDataStorage.swiper.isEnd;
    if (!this.reachedEnd || this.reachedEnd) {
      this.isStart = ev.el.dom7ElementDataStorage.swiper.isBeginning;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(async () => {
      this.reachedEnd = await this.slideSv.isEnd(this.slides);
    });
  }

  async showSocials(ev) {
    const socials = ev?.detail?.value || ev;
    if (!socials.detail) {
      const { data } = await this.uiSv.showPopover(ContactSocialComponent, {
        socials,
        gallery: this.galleries,
      });
      this.open(data);
      this.selectBranch.value = undefined;
    }
    // ev.detail && (ev.detail.value = undefined);
  }
}
